<template>
  <center>
    <div :key="renderKey">
      <div class="card card-body agatrs-card-style">
        <Header pageTitle="Edit IA" class="card-container"></Header>
        <div class="row">
          <div class="col-md-6">
            <label for="iaName">IA Name</label>
            <base-input
              id="iaName"
              v-model="selectedName"
              name="Name"
              placeholder="Please type name."
            ></base-input>
            <label for="iaRemark">IA Remark</label>
            <base-input
              id="iaRemark"
              v-model="selectedRemark"
              name="Remark"
              placeholder="Please type a remark."
            ></base-input>
          </div>

          <div class="col-md-6">
            <el-table :data="implementingArrangements.files" role="table"
        aria-label="Implementing Arrangement Files Table">
              <el-table-column :min-width="50" align="left" label="Actions">
                <div slot-scope="props">
                  
                  <el-tooltip
                    content="Download Document"
                    :open-delay="300"
                    effect="light"
                    placement="top"
                  >
                    <router-link
                      :to="`/api/implimentarrangementfiles/${props.row.id}`"
                      class="btn-link btn-primary"
                      target="_blank"
                    >
                      <i class="tim-icons icon-cloud-download-93"></i>
                      <span class="hide-if-large-screensize">Download</span>
                    </router-link>
                  </el-tooltip>
                  <el-tooltip
                    content="Delete File."
                    :open-delay="300"
                    effect="light"
                    placement="top"
                  >
                    <a
                      href="#"
                      @click="deleteFile(props.row.id, props.row.file.name)"
                      class="btn-link btn-danger"
                    >
                      <i class="tim-icons icon-trash-simple"></i>
                      <span class="hide-if-small-screensize">Delete</span>
                    </a>
                  </el-tooltip>
                </div>
              </el-table-column>
              <el-table-column
                v-for="fileColumn in filesColumns"
                :key="fileColumn.label"
                :min-width="fileColumn.minWidth"
                sortable
                :formatter="fileColumn.formatter"
                :prop="fileColumn.prop"
                :label="fileColumn.label"
              >
              </el-table-column>
            </el-table>
            <div class="col-md-4 offset-md-2">
              <base-button
                @click="openModal()"
                class="btn-dark float-sm-none float-md-left"
                ><i class="tim-icons icon-simple-add"></i> New IA
              </base-button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 align-left">
            <div class="col-md-4">
              <base-button
                type="primary"
                @click="returnToEditIAs()"
                class="btn-primary"
              >
                <i class="tim-icons icon-double-left"></i> Return (Edit IAs)
              </base-button>
            </div>
            <div class="col-md-2 offset-md-7">
              <base-button
                @click="saveImplementingArrangement()"
                class="btn"
                type="primary"
                v-b-popover.hover.bottom="'Upload IA Document'"
              >
                <i class="tim-icons icon-send"></i> Save IA
              </base-button>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        ref="showIAModal"
        scrollable
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
        body-class="custom_alert_body"
      >
        <div class="alert_header align-center">Add IA Document</div>

        <div class="container">
          <label for="iaFileUpload">IA File Upload:</label>
          <base-input class="pt-20" :error="getError('file')">
            <input
              id="iaFileUpload"
              v-validate="'required'"
              name="file"
              accept=".xls,.xslx,.png,.jpg,.jpeg,.pdf"
              type="file"
              ref="file"
              @change="handleFileUpload"
              placeholder="IA Document"
            />
            <b
              ><small
                >*PDF/XLS/PNG/JPG Document files with a size less than
                10MB</small
              ></b
            >
          </base-input>
        </div>

        <div class="alert_footer align-center">
          <base-button
            type="primary"
            @click="clickCloseModal()"
            class="btn-primary"
            ><i class="tim-icons icon-double-left"></i> Back</base-button
          >
          <base-button
            @click="saveIaFile()"
            class="btn float-right"
            type="primary"
            v-b-popover.hover.bottom="'Upload IA Document'"
          >
            <i class="tim-icons icon-cloud-upload-94"></i> Upload
          </base-button>
        </div>
      </b-modal>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn } from "element-ui";
import axios from "@/axios";
import swal from "sweetalert2";
import Header from "@/components/App/Header.vue";
import Utility from "@/mixins/utility/utility";
import Util from "@/util/util";

export default {
  mixins: [Utility],
  name: "EditIaFiles",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Header,
  },
  data() {
    return {
      implementingArrangements: [],
      file: "",
      acsaId: "",
      countryId: "",
      selectedName: "",
      selectedRemark: "",
      filesColumns: [
        {
          prop: "id",
          label: "File ID",
          minWidth: 50,
        },
        {
          prop: "file.name",
          label: "Name",
          minWidth: 50,
        },
      ],
    };
  },
  mounted() {
    this.getIaByIAId();
  },
  methods: {
    ...mapActions({
      saveIaFile: "IAAgreement/saveIaFile",
      getIAAgreement: "IAAgreement/getIAAgreement",
    }),
    getIaByIAId() {
      this.axios
        .get(`api/implimentarrangements/${this.$route.params.id}`)
        .then((response) => {
          this.implementingArrangements = response.data;
          this.selectedName = response.data.name;
          this.selectedRemark = response.data.remark;
          this.acsaId = response.data.acsaAgreementId;
          this.getCountryId();
        });
    },
    getCountryId() {
      this.axios.get(`api/acsaagreements/${this.acsaId}`).then((response) => {
        this.countryId = response.data.countryId;
      });
    },
    openModal() {
      this.$refs.showIAModal.show();
    },
    clickCloseModal() {
      this.$refs.showIAModal.hide();
    },
    async initiateDownload(id) {
      let ctx = this;
      await axios({
        url: `api/implimentarrangementfiles/blob/${id}`,
        method: "GET", // important
      }).then((response) => {
        Util.fileDownload(response.data.file.image, response.data.file.name);
      });
    },
    deleteFile(fileId, fileName) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete: "${fileName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete File #${fileId}!`,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          axios
            .delete(`api/implimentarrangementfiles/delete/${fileId}`)
            .then((response) => {
              new swal({
                title: "Confirmation of Delete",
                text: `"${fileName}" has been deleted successfully.`,
                icon: "success",
                confirmButtonColor: "#10b45a",
              });
              this.getIaByIAId();
            });
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    returnToEditIAs() {
      this.$router.push(`/admin/acsas/${this.countryId}`);
    },
    saveImplementingArrangement() {
      let newIAAgreement = {
        acsaAgreementId: this.acsaId,
        implimentArrangementId: this.$route.params.id,
        name: this.selectedName,
        remark: this.selectedRemark,
      };
      axios
        .post("api/implimentarrangements", newIAAgreement)
        .then((response) => {
          this.getIaByIAId();
        });
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    saveIaFile() {
      let ctx = this;
      ctx.$validator.validateAll().then((isValid) => {
        if (isValid) {
          let formData = new FormData();

          formData.append("arrangementId", this.$route.params.id);
          formData.append("IFile", ctx.file);

          axios
            .post("/api/implimentarrangementfiles/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(() => {
              this.clickCloseModal();
              this.getIaByIAId();
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.form-group input[type="file"] {
  opacity: inherit;
  position: inherit;
  top: inherit;
  right: inherit;
  bottom: inherit;
  left: inherit;
  width: inherit;
  height: inherit;
  z-index: inherit;
}
</style>
